import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  const nav = useNavigate();
  return (
    <div className="app-shell bg-aurora min-h-screen pb-10" data-testid="terms-page">
      <div className="px-6 pt-10 flex items-center gap-3 mb-4">
        <button onClick={() => nav(-1)} className="w-10 h-10 rounded-full bg-white/80 flex items-center justify-center shadow-sm">
          <ArrowLeft size={18} />
        </button>
        <h1 className="font-display text-3xl text-[#332D38]">Podmínky použití</h1>
      </div>

      <div className="px-6 space-y-4 text-sm leading-relaxed text-[#332D38]">
        <p className="text-[#8A7E91] text-xs">Verze 1.0 — poslední aktualizace: {new Date().toLocaleDateString("cs-CZ")}</p>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">1. Kdo jsme</h2>
          <p>Sentra je česká seznamovací aplikace s AI, která ti pomáhá pochopit vztahy — analýzu konverzací, kompatibilitu a bezpečnost při rande. Provozovatel: Sentra AI, kontakt: <span className="text-[#0F3D34] underline">podpora@sentra.cz</span>.</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">2. Věková hranice</h2>
          <p>Sentra je určena <strong>výhradně pro osoby starší 18 let</strong>. Registrací potvrzuješ, že jsi zletilá/zletilý. Pokud zjistíme, že uživatel je mladší 18 let, jeho účet neprodleně smažeme.</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">3. Chování na platformě</h2>
          <p>Zavazuješ se, že:</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>Nebudeš obtěžovat, zastrašovat ani vyhrožovat jiným uživatelům.</li>
            <li>Nebudeš nahrávat urážlivý, násilný nebo sexuálně explicitní obsah.</li>
            <li>Nebudeš se vydávat za jinou osobu ani vytvářet falešné profily.</li>
            <li>Nebudeš platformu používat pro spam, podvody nebo reklamu.</li>
            <li>Budeš respektovat soukromí ostatních — nesdílej screenshoty konverzací bez souhlasu.</li>
          </ul>
          <p className="mt-2">Porušení podmínek vede k <strong>okamžitému zablokování účtu</strong> bez nároku na vrácení peněz.</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">4. Nulová tolerance k obtěžování</h2>
          <p>Kterýkoli uživatel může být <strong>zablokován nebo nahlášen</strong>. Nahlášení řešíme do 24 hodin. Vážné případy (obtěžování, výhrůžky) vedou k okamžitému smazání účtu porušovatele.</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">5. AI analýzy</h2>
          <p>AI analýzy konverzací (Claude Sonnet od Anthropic) jsou <strong>orientační</strong> a nikdy nenahrazují odbornou psychologickou pomoc. Sentra nenese odpovědnost za rozhodnutí učiněná na základě AI výstupů.</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">6. Premium a platby</h2>
          <p>Premium předplatné (249 Kč/měs nebo 1 990 Kč/rok) se automaticky obnovuje. Zrušit můžeš kdykoli v nastavení. Refund do 14 dní od nákupu podle zákona o ochraně spotřebitele.</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">7. Ukončení účtu</h2>
          <p>Účet můžeš kdykoli smazat v Nastavení. Všechna data (profil, matche, zprávy, analýzy) budou <strong>okamžitě a trvale smazána</strong>. Anonymizované záznamy o platbách uchováváme dle daňového zákona.</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">8. Odpovědnost</h2>
          <p>Sentra je poskytována „tak jak je“. Neneseme odpovědnost za jednání jiných uživatelů. <strong>Rande vždy plánuj bezpečně</strong> — použij funkci Safe Date, sděl místo důvěryhodné osobě.</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">9. Změny podmínek</h2>
          <p>Podmínky můžeme upravit. O významných změnách informujeme e-mailem nebo v aplikaci minimálně 14 dní dopředu.</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">10. Kontakt</h2>
          <p>Podpora: <span className="text-[#0F3D34] underline">podpora@sentra.cz</span></p>
          <p>Rozhodné právo: Česká republika</p>
        </section>

        <Link to="/privacy" className="block text-center py-3 text-[#0F3D34] font-medium underline">Přečti si i Ochranu osobních údajů →</Link>
      </div>
    </div>
  );
}
